module.exports = __webpack_public_path__ + "static/m_solution13-4b5df1672fb53ae11e8c41a4fbad45d9.png";